import React from 'react';
import UploadInput from '../input/UploadInput';
import MenuSection from '../../common/sections/MenuSection/index';
import {Link} from 'react-router-dom';

export default ({ onData, onError, canContinue }) => {
    return (<div>
        <div className="HrcsEditor-warning">
            <div className="content">
                <span>
                    Denne løsningen krever en moderne nettleser som <a href="https://www.google.com/chrome/browser/desktop/index.html">Chrome</a> eller <a href="https://www.mozilla.org/">Firefox</a>.
                    Internet Explorer vil ikke fungere pga. manglende (eller svak) støtte for filbehandling.
                </span>
            </div>
        </div>
        <MenuSection>
            <UploadInput className="HrcsEditor-button" onData={onData} onError={onError}>Last opp regneark</UploadInput>
            { canContinue ?
                <Link className="Button" to="/editor/2">Fortsett redigering</Link> : null
            }
        </MenuSection>
        <div className="content">
            <p>
                Registrering her skal kun brukes dersom du har fått instrukser om det.
            </p>

            <h2>Brukerveiledning</h2>

            <p>
                Hensikten med dette skjemaet er å fylle ut HRCS-koder for forskere (eller ansatte). Det skal fylles inntil to forskningsaktiviteter og
                inntil fem helsekategorier for hver forsker. <strong>Summen av andelene for hver av de to dimensjonene må være 100 %</strong>.
                Systemet gir beskjed dersom andelene ikke summeres til 100 %.
            </p>

            <ol>
                <li>Last opp regneark som inneholder en liste med forskere (f.eks. forskere.xlsx)</li>
                <li>Fyll inn HRCS-data</li>
                <li>Last ned regneark med utfylt data</li>
                <li>Send det utfylte regnearket til HRCS-ansvarlig ved egen institusjon</li>
            </ol>

            <h3>Meldinger i skjemaet</h3>

            <p>
                Skjemaet har en rad for hver person. Hver rad kan ha en av de fire tilstandene beskrevet nedenfor. Når alle
                radene er markert som <strong>ferdig utfylt</strong> kan regnearket lastes ned og sendes inn til registrering.
            </p>

            <ul className="BoxList BoxList-stateless">
                <li><a title="Ikke påbegynt"><span className="fa fa-fw"></span> Ikke påbegynt (viser tomt ikon)</a></li>
                <li><a className="status-active" title="Redigeres"><span className="fa fa-pencil"></span> Redigeres</a></li>
                <li><a className="status-ok" title="Ok"><span className="fa fa-check"></span> Ferdig utfylt</a></li>
                <li><a className="status-error" title="Mangler helsekategori"><span className="fa fa-exclamation"></span> Ikke fullstendig utfylt</a></li>
            </ul>

            <p>
                Hold musepekeren over raden (eller statusikonet) for å se en liste over mangler når raden er markert som <strong>ikke fullstendig utfylt</strong>.
            </p>

            <h3>Lagring</h3>

            <p>
                Skjemaet lagres automatisk på din datamaskin når du redigerer radene slik at det er mulig å fortsette på samme registrering
                selv om du lukker nettleseren eller slår av datamaskinen. Neste gang du åpner nettsiden så vil du få muligheten til å fortsette
                å redigere filen du lastet opp tidligere, eller laste opp en ny fil. Merk at eksisterende skjema vil slettes i det du laster
                opp en ny fil, det er derfor viktig å laste ned resultatene fra registreringen før starter på neste regneark.
            </p>

            <p>
                Når du er ferdig med å fylle inn skjemaet kan det lastes ned som et regneark som åpnes
                i <a href="https://no.libreoffice.org/">LibreOffice</a> eller <a href="https://products.office.com/nb-no/excel">Excel</a>. Det er mulig
                å laste dette regnearket opp til editoren igjen og fortsette redigeringen fra tidspunktet når regnearket ble lastet ned. For at editoren
                skal kunne tolke filen riktig må kolonneoverskriftene for HRCS-feltene ikke endres.
            </p>

            <h3>Eksempel på gyldig registrering av enkeltperson</h3>

            <p className="Note Note-mono status-ok">
                Navn:<br />Ola Normann<br /><br />

                Forskningsaktivitet:<br />
                50 % Årsaksforhold og 50 % Forebygging<br /><br />

                Helsekategori:<br />
                25 % Hjerte kar, 25 % Mental helse, 25 % Stoffskifte og hormoner og 25 % Kreft<br />
            </p>

            <p>
                Her er det registrert totalt 100% på forskningskategorier og 100% på helsektategoriene. Dette er en tilstrekkelig HRCS-registrering.
            </p>

            <h3>Eksempel på ufullstendig registrering av enkeltperson</h3>

            <p className="Note Note-mono status-error" title="Summen av forskningsaktivitetene er kun 90 %">
                Navn:<br />Kari Normann<br /><br />

                Forskningsaktivitet:<br />
                40 % Påvisning og diagnose og 50 % Utvikling av behandlinger<br /><br />

                Helsekategori:<br />
                50 % Øre og 50 % Øye
            </p>

            <p>
                I dette tilfellet er summen av forskningsaktivitetene kun 90 % og resulterer derfor i en ufullstendig
                registrering. Det er mulig å få beskrivelse av manglene ved å holde musepekeren over raden i skjemaet.
            </p>
        </div>
    </div>);
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/steps/IntroductionStep.js